import { call, put, takeLatest } from "redux-saga/effects";
import RefreshTokenRequest from "Communication/ApiClasses/RefreshTokenRequest";
import {
  REFRESH_TOKEN_TIME,
  TOKEN_KEY,
  REFRESH_TIMER_ID,
} from "Communication/Constants";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  signalTokenRefreshStart,
  signalTokenRefreshComplete,
  signalTokenRefreshError,
} from "./SagaCoordinator";

// worker
function* handleRefreshToken(action) {
  // Signal that token refresh has started - this will block other sagas
  yield call(signalTokenRefreshStart);

  try {
    const strTimestamp = `${action.timeout.toString()}000`;
    const timestampNow = Number(strTimestamp);
    const RefreshTokenApi = new RefreshTokenRequest(
      sessionStorage.getItem(TOKEN_KEY)
    );
    console.log(
      "refresh",
      timestampNow - new Date().getTime() - REFRESH_TOKEN_TIME
    );
    const timerID = yield call(
      setInterval,
      () => {
        RefreshTokenApi.getData().then((res) => {
          sessionStorage.setItem(TOKEN_KEY, res.data.token);
        });
      },
      timestampNow - new Date().getTime() - REFRESH_TOKEN_TIME
    );
    sessionStorage.setItem(REFRESH_TIMER_ID, timerID);

    // Signal that token refresh has completed successfully
    yield call(signalTokenRefreshComplete);
  } catch (error) {
    // Signal that token refresh has failed
    yield call(signalTokenRefreshError);

    yield put({
      type: actionTypes.SIGNIN_ERROR,
      error,
    });
  }
}

// watcher
export default function* refreshTokenSaga() {
  yield takeLatest(actionTypes.GET_ACCESS_TOKEN, handleRefreshToken);
}
